module.exports = __webpack_public_path__ + "img/img-22.d25b7c12.jpeg";